import { FormAnswerValue } from './survey-ai-forms.types';

interface RatingOption {
  value: string;
}

export function pickDefaultRatingOption<T extends RatingOption>(
  options: readonly T[],
  numberOfOptions: number
): T | undefined {
  return options[Math.floor(numberOfOptions / 2)];
}

export function seedRatingDefaultIfUnset({
  value,
  options,
  numberOfOptions,
  currentOptionIndex,
  onChange,
}: {
  value: FormAnswerValue;
  options: readonly RatingOption[];
  numberOfOptions: number;
  currentOptionIndex: number | undefined;
  onChange: (value: string) => void;
}): void {
  if (value || options.length === 0 || currentOptionIndex !== undefined) return;

  const defaultOption = pickDefaultRatingOption(options, numberOfOptions);
  if (defaultOption) {
    onChange(defaultOption.value);
  }
}
